import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useRegister from '@hooks/auth/useRegister';

function RegisterPage() {
  const navigate = useNavigate();
  const { registerUser, isSubmitting, error, success } = useRegister();
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  function handleChange(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      await registerUser(form);
      setTimeout(() => navigate('/login'), 900);
    } catch (err) {}
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <h1 className="auth-title">Register CMS User</h1>
        <p className="auth-subtitle">Create the administrator user to sign in.</p>
        <form className="form-grid" onSubmit={handleSubmit}>
          <label className="field-label" htmlFor="name">
            Name
            <input
              className="field-input"
              id="name"
              name="name"
              type="text"
              value={form.name}
              onChange={handleChange}
              required
            />
          </label>
          <label className="field-label" htmlFor="email">
            Email
            <input
              className="field-input"
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </label>
          <label className="field-label" htmlFor="password">
            Password
            <input
              className="field-input"
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </label>
          {error ? <p className="message-error">{error}</p> : null}
          {success ? <p className="message-ok">{success}</p> : null}
          <button className="button-primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Registering...' : 'Register'}
          </button>
        </form>
        <div className="auth-links">
          <Link to="/login">I already have an account</Link>
        </div>
      </section>
    </main>
  );
}

export default RegisterPage;
